// Enhanced color palette matching the first dashboard
export const COLORS = [
    "#4F46E5", // Indigo
    "#10B981", // Emerald
    "#F59E0B", // Amber
    "#EF4444", // Red
    "#8B5CF6", // Violet
    "#06B6D4", // Cyan
    "#84CC16", // Lime
    "#F97316", // Orange
    "#EC4899", // Pink
  ];
  
  export const EMPLOYEE_CATEGORIES = {
    BOARD_OF_DIRECTORS: 'Board of Directors',
    KEY_MANAGERIAL_PERSONNEL: 'Key Managerial Personnel',
    EMPLOYEES_OTHER: 'Employees other than BoD and KMPs',
    OTHER_THAN_PERMANENT_EMPLOYEES: 'Other than Permanent Employees',
    WORKERS: 'Workers',
    OTHER_THAN_PERMANENT_WORKERS: 'Other than Permanent Workers'
  };

  /**
   * Canonical ordered list of the six BRSR stakeholder segments, shared by every
   * table/hook that iterates segments (principle-coverage rows, compliance
   * categories) so their row order stays in lockstep and a segment is added or
   * removed in exactly one place.
   */
  export const ORDERED_SEGMENTS = [
    EMPLOYEE_CATEGORIES.BOARD_OF_DIRECTORS,
    EMPLOYEE_CATEGORIES.KEY_MANAGERIAL_PERSONNEL,
    EMPLOYEE_CATEGORIES.EMPLOYEES_OTHER,
    EMPLOYEE_CATEGORIES.OTHER_THAN_PERMANENT_EMPLOYEES,
    EMPLOYEE_CATEGORIES.WORKERS,
    EMPLOYEE_CATEGORIES.OTHER_THAN_PERMANENT_WORKERS
  ];

  /**
   * Display labels for the principle-coverage tables, clarifying that the Employees
   * and Workers segments count permanent staff. The other-than-permanent segments,
   * BoD and KMP use their plain EMPLOYEE_CATEGORIES label (look up via
   * SEGMENT_DISPLAY_LABELS[seg] || seg).
   */
  export const SEGMENT_DISPLAY_LABELS = {
    [EMPLOYEE_CATEGORIES.EMPLOYEES_OTHER]: `${EMPLOYEE_CATEGORIES.EMPLOYEES_OTHER} (Permanent employees)`,
    [EMPLOYEE_CATEGORIES.WORKERS]: `${EMPLOYEE_CATEGORIES.WORKERS} (Permanent workers)`
  };
  
  export const TRAINING_CATEGORIES = {
    HEALTH_SAFETY: 'Health & Safety',
    SKILL_DEVELOPMENT: 'Skill Development',
    HUMAN_RIGHTS: 'Human Rights'
  };
  
  export const CHART_DIMENSIONS = {
    DEFAULT_HEIGHT: 400,
    DEFAULT_WIDTH: 800,
    MARGIN: { top: 40, right: 80, bottom: 120, left: 80 }
  };

  /**
   * Maps each employee/worker category shown in the EmployeeStats cards to the
   * `zb_reporting_question_titles` ids that hold its company-wide headcount in
   * `riu_quantative_data`. These totals are the denominator ("out of") we compare
   * the trained/registered counts against.
   */
  export const HEADCOUNT_TITLE_IDS = {
    'BOD': { male: 10017, female: 10018 },
    'KMP': { male: 10019, female: 10020 },
    'Permanent Employee': { male: 10011, female: 10012 },
    'Other than Permanent Employee': { male: 10013, female: 10014 },
    'Permanent Worker': { male: 10015, female: 10016 },
    'Other than Permanent Worker': { male: 10033, female: 10034 }
  };

  /**
   * Flat list of every headcount title id, ready to pass as `questionIds` to the
   * optimized-analytics endpoint.
   */
  export const HEADCOUNT_TITLE_ID_LIST = Object.values(HEADCOUNT_TITLE_IDS)
    .flatMap(({ male, female }) => [male, female]);

  /**
   * Category groupings used to build the denominators for the summary StatsCards:
   * employee coverage sums the two employee buckets, worker coverage sums the two
   * worker buckets, and monthly participants sum the whole workforce (all six).
   */
  export const EMPLOYEE_HEADCOUNT_CATEGORIES = ['Permanent Employee', 'Other than Permanent Employee'];
  export const WORKER_HEADCOUNT_CATEGORIES = ['Permanent Worker', 'Other than Permanent Worker'];
  export const WORKFORCE_HEADCOUNT_CATEGORIES = Object.keys(HEADCOUNT_TITLE_IDS);